import { IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { Instagram as InstagramIcon, Twitter as TwitterIcon, Facebook as FacebookIcon } from '@mui/icons-material';

const StyledIconButton = styled(IconButton)(({ hoverColor = "steelBlue" }) => ({
  transition: 'transform 0.3s ease-in-out, color 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.1)',
    color: hoverColor,
    backgroundColor: 'transparent',
  },
}));

const SocialMediaButton = ({ iconName, link, hoverColor }) => {
  let IconComponent;

  switch (iconName) {
    case 'Instagram':
      IconComponent = InstagramIcon;
      break;
    case 'Twitter':
      IconComponent = TwitterIcon;
      break;
    case 'Facebook':
      IconComponent = FacebookIcon;
      break;
    default:
      IconComponent = null;
  }

  if (!IconComponent) return null;

  return (
    <StyledIconButton
      aria-label={iconName}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ color: "darkGrey" }}
      hoverColor={hoverColor}
    >
      <IconComponent fontSize="large" />
    </StyledIconButton>
  );
};

export default SocialMediaButton;